import {
    genericPage,
    getServerSidePropsHelper,
    getMappingEleccions3CatInfo,
    getSlugEleccio,
    getBasePathEleccio
} from 'components/3catinfo/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions']);
};

export async function getServerSideProps(context) {
    const { slug, preview } = context.query;
    const basePath = getBasePathEleccio(context?.resolvedUrl);
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    if (__isEmpty(mapping)) {
        return {
            notFound: true
        };
    }
    const estat = preview || mapping.fase;
    let path = [...basePath, 'pactometre', 'sondeig'];
    if (estat === 'escrutini') {
        path = [...basePath, 'pactometre', 'escrutini'];
    } else if (estat === 'final') {
        path = [...basePath, 'pactometre', 'final'];
    }

    const options = {
        slugs: path,
        id: mapping.id,
        slug
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
